var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagKey = function SvgTagKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tag_key_svg__Capa_2",
    viewBox: "0 0 14.7 13.86"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tag_key_svg__Capa_1-2",
    d: "m14.7 10.25-.71-.71-1.58 1.58-.91-.91 1.58-1.58-.71-.71-1.58 1.58-2.58-2.58a4.5 4.5 0 0 0 .74-2.45C8.96 2.01 6.95 0 4.48 0S0 2.01 0 4.48s2.01 4.48 4.48 4.48c1.2 0 2.29-.48 3.1-1.26l6.16 6.16.71-.71-1.32-1.32 1.58-1.58ZM4.48 7.95C2.56 7.95 1 6.39 1 4.47S2.56.99 4.48.99s3.48 1.56 3.48 3.48S6.4 7.95 4.48 7.95",
    fill: "#22aa9e"
  })));
};
export default SvgTagKey;